export default "__VITE_ASSET__e4afbd49__"